import { BookingAction } from '../actions/booking-action';
import { BufferstockOnlyFromBufferstockAction } from '../actions/bufferstock-only/bufferstock-only-from-bufferstock-action';
import { BufferstockOnlyFromMachineAction } from '../actions/bufferstock-only/bufferstock-only-from-machine-action';
import { StockSourceType } from '../types';
import { BookingWorld, WorldKind } from './booking-world';

/**
 * Nur Bufferstock aktiv (Lyreco). Die Quelle KFZ existiert nicht.
 */
export class BufferstockOnlyWorld implements BookingWorld {
  public readonly kind: WorldKind = 'bufferstock-only';

  private readonly actions: Partial<Record<StockSourceType, BookingAction>> = {
    [StockSourceType.BUFFERSTOCK]: new BufferstockOnlyFromBufferstockAction(),
    [StockSourceType.MACHINE]: new BufferstockOnlyFromMachineAction(),
  };

  /**
   * Liefert die Source-Action für die Bufferstock-only-Welt.
   * @param source Quell-Lagertyp der Buchung.
   * @returns Die Action für BUFFERSTOCK oder MACHINE, sonst undefined (z.B. für CAR).
   */
  public actionFor(source: StockSourceType): BookingAction | undefined {
    return this.actions[source];
  }
}
